import { useCallback, useState } from "react";

export default function useToggle() {
  const [state, setState] = useState(false);
  return {
    open: state,
    toggleOpen: useCallback(() => setState(!state), [state]),
  };
}
